// extracted by mini-css-extract-plugin
export default {"container":"style_container__RS8Yu","aboutInfoContainer":"style_aboutInfoContainer__xAC3V","aboutInfoItem":"style_aboutInfoItem__yf8Pl","creatorInfo":"style_creatorInfo__LFU0l"};